import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../lib/api";
import ProductCard from "../components/ProductCard";

export default function Shop() {
  const [params, setParams] = useSearchParams();
  const category = params.get("category") || "";
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const url = category ? `/products?category=${category}` : "/products";
    api.get(url).then(({ data }) => {
      setProducts(data);
      setLoading(false);
    });
  }, [category]);

  const setCat = (c) => {
    if (!c) setParams({});
    else setParams({ category: c });
  };

  return (
    <div className="pt-32 pb-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-12 md:mb-20">
          <div className="label-eyebrow mb-4">The Collection</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter">
            {category ? category[0].toUpperCase() + category.slice(1) : "All Shoes"}
          </h1>
        </div>

        <div className="flex gap-8 mb-12 border-b border-[#e5e5e5] pb-6 text-sm flex-wrap">
          {[
            { k: "", label: "All" },
            { k: "loafers", label: "Loafers" },
            { k: "slip-ons", label: "Slip-Ons" },
            { k: "chelsea", label: "Chelsea" },
            { k: "derby", label: "Derby" },
            { k: "monk", label: "Monk" },
            { k: "heritage", label: "Heritage" },
            { k: "wedding", label: "Wedding" },
          ].map((f) => (
            <button
              key={f.k || "all"}
              onClick={() => setCat(f.k)}
              className={`transition-opacity ${
                category === f.k ? "font-semibold" : "text-[#666] hover:opacity-70"
              }`}
              data-testid={`filter-${f.k || "all"}`}
            >
              {f.label}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="text-sm text-[#666]">Loading…</div>
        ) : products.length === 0 ? (
          <div className="text-sm text-[#666]" data-testid="no-products">
            No products found.
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
            {products.map((p) => (
              <ProductCard key={p.id} product={p} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
